import React, { useMemo, useState, useEffect, useCallback } from 'react'

import { Card, Button, Switch } from '@material-ui/core'
import FormItem from 'components/FormItem'
import { assign } from 'lodash'
import { mealIngredientCategoryUpsertPromise } from 'api/MealIngredientCategory'
import { isBlank } from 'common/usual'

export default function MealCategoryUpsertForm (props) {
  const { data } = props
  const [category, setCategory] = useState({})
  const [btnStatus, setBtnStatus] = useState(false)

  const disableBtn = useMemo(() => (
    btnStatus || isBlank(category.title)
  ), [btnStatus, category.title])

  useEffect(() => {
    setCategory(data)
  }, [data])

  function handleSubmit () {
    setBtnStatus(true)
    mealIngredientCategoryUpsertPromise(category)
      .then(res => {
        if (!category.id) {
          props.history.push('/meal-ingredient/categories')
        }
        category.id = res.id
      }).finally(() => {
        setBtnStatus(false)
      })
  }

  const handleChange = useCallback((...values) => {
    setCategory(
      assign({}, category, ...values)
    )
  }, [category])

  const commonProps = useMemo (() => ({
    onChange: handleChange,
    data: category
  }), [handleChange, category])

  return (
    <div className={'root'}>
      <Card className={'form-container'}>
        <FormItem label={'Title'} name={'title'} {...commonProps} />
        <FormItem label={'Sort'} name={'sort'} type={'number'} {...commonProps} />
        
        <FormItem label={'Active'} name={'active'}>
          <Switch
            checked={Boolean(category.active)}
            onChange={e => {
              handleChange({ active: e.target.checked })
            }}
            name="active"
            inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
        </FormItem>

        <Button
          className="save-btn"
          color="primary"
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          onClick={handleSubmit}
          disabled={disableBtn}
        >
          SUBMIT
        </Button>
      </Card>

      {/* <div>{JSON.stringify(category)}</div> */}
    </div>
  )
}